import { Component } from '@angular/core';
import { RouterOutlet } from "@angular/router";
import { FooterComponent } from "src/app/core/components/footer/footer.component";
import { HeaderComponent } from "src/app/core/components/header/header.component";

@Component({
    selector: 'app-main-layout',
    imports: [FooterComponent, RouterOutlet, HeaderComponent],
    templateUrl: './main-layout.component.html',
    standalone: true,
    styleUrl: './main-layout.component.scss'
})
export class MainLayoutComponent {

}
